function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { identify, setBaseProperties } from '@adsk/acs-web-analytics';
import { UserProvider, SubscriptionsProvider, useOptionalUser } from '@adsk/alloy-provider';
import { LocaleProvider } from '@adsk/alloy-react-locale';
import { Reset } from '@adsk/alloy-react-theme';
import ConnectedTopNavigationOptionalUser from './ConnectedTopNavigationOptionalUser';
import TopNavigationLayout from './TopNavigationLayout';
const AnalyticsInitializer = () => {
  const {
    data: user,
    loading
  } = useOptionalUser();
  const notApplicable = 'N/A';
  useEffect(() => {
    user && !loading && identify(user.analyticsId, _objectSpread({}, user));
  }, [loading, user]);
  useEffect(() => {
    setBaseProperties({
      license: notApplicable,
      tool_id: notApplicable,
      product_id: notApplicable,
      account_id: notApplicable,
      project_id: notApplicable
    });
  }, []);
  return null;
};

/**
 * PublicPageLayout component is the root component to show a page view for both logged in and logged out users.
 * This component should be used for public links, where the user may or may not be logged in.
 * This component **would not redirect** the user to login page if the user is not logged in.
 */
const PublicPageLayout = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    children,
    onLogout,
    locale,
    renderAboveLayout
  } = _ref;
  return /*#__PURE__*/React.createElement(LocaleProvider, {
    locale: locale
  }, /*#__PURE__*/React.createElement(Reset, null), /*#__PURE__*/React.createElement(UserProvider, {
    redirectLoggedOutUsers: false
  }, /*#__PURE__*/React.createElement(SubscriptionsProvider, null, /*#__PURE__*/React.createElement(AnalyticsInitializer, null), /*#__PURE__*/React.createElement(TopNavigationLayout, {
    ref: ref,
    renderTopNavigation: () => /*#__PURE__*/React.createElement(ConnectedTopNavigationOptionalUser, {
      onLogout: onLogout
    }),
    renderAboveLayout: renderAboveLayout
  }, children))));
});
PublicPageLayout.displayName = 'PublicPageLayout';
PublicPageLayout.propTypes = {
  /** Page content */
  children: PropTypes.node,
  /** callback called on logout */
  onLogout: PropTypes.func,
  /** localization, default: en */
  locale: PropTypes.string,
  /** Items that will render above the layout*/
  renderAboveLayout: PropTypes.func
};
export default PublicPageLayout;
//# sourceMappingURL=PublicPageLayout.js.map